import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import {naive} from './components/naive-ui'
import { createPinia } from 'pinia'

const app = createApp(App)
const pinia = createPinia()


app
.use(router)
.use(naive)
.use(pinia)
.mount('#app')
